module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dashboard":"Dashboard","login":"Login","logout":"Logout"}}')
  delete Component.options._Ctor
}
